<ng-container *transloco="let t; prefix: 'property-upload-wizard'">
  <div class="flex flex-col gap-4 justify-self-start my-4">
    <p class="rfs:text-base text-gray-900 text-center font-semibold">
      {{ t("propertyType.stepOne") }}
    </p>
  </div>
</ng-container>
<app-select-buttons
  [Buttons]="Buttons"
  [ToggledButtons]="ToggledButtons"
  [IsMultiple]="IsMultiple"
  (SelectedItems)="toggleSelect($event)"
  ><app-select-buttons> </app-select-buttons
></app-select-buttons>
